import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { selectors } from '~/store/state-selectors';
export const useInvoiceMetrics = function useInvoiceMetrics(filters) {
    let { enabled = true } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const { INVOICE_DASHBOARD_METRICS } = useFeatureFlags();
    const sinceKey = filters.issuedOnSince ? filters.issuedOnSince.getTime() : null;
    const untilKey = filters.issuedOnUntil ? filters.issuedOnUntil.getTime() : null;
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.InvoiceMetrics,
            businessId,
            sinceKey,
            untilKey
        ],
        queryFn: ()=>{
            var _filters_issuedOnSince, _filters_issuedOnUntil;
            return api.invoice.getMetrics(businessId, {
                issuedOnSince: (_filters_issuedOnSince = filters.issuedOnSince) !== null && _filters_issuedOnSince !== void 0 ? _filters_issuedOnSince : undefined,
                issuedOnUntil: (_filters_issuedOnUntil = filters.issuedOnUntil) !== null && _filters_issuedOnUntil !== void 0 ? _filters_issuedOnUntil : undefined
            });
        },
        enabled: enabled && businessId != null && INVOICE_DASHBOARD_METRICS,
        keepDataFresh: true
    });
    return {
        metrics: data,
        isLoading,
        error,
        refresh
    };
};
